export default {
  scenes: {
    messagesLeftOnRead: {
      beats: {
        theSilenceGrows: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliVilla'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'Days pass, and the change is undeniable now. Eric replies slower, shorter. Some messages go unanswered altogether.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'How should I handle this?',
              choices: [
                {
                  text: 'Confront Him Directly',
                  next: {
                    scene: 'messagesLeftOnRead',
                    beat: 'confrontDirect'
                  }
                },
                {
                  text: 'Pretend It Doesn\'t Bother Her',
                  next: {
                    scene: 'messagesLeftOnRead',
                    beat: 'pretendUnbothered'
                  }
                }
              ]
            }
          ]
        },
        confrontDirect: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Something\'s different. Just be honest with me.'
            },
            {
              type: 'showNarration',
              text: 'Eric: (seen, no reply).'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.3
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'It\'s like talking to a stranger.'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'aLastAttempt',
            beat: 'theInvitation'
          }
        },
        pretendUnbothered: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Busy week? No worries, catch up later.'
            },
            {
              type: 'showNarration',
              text: 'Eric: (hours later) Yeah. Busy.'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.3
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'It\'s like talking to a stranger.'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'aLastAttempt',
            beat: 'theInvitation'
          }
        }
      }
    },
    aLastAttempt: {
      beats: {
        theInvitation: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliVilla'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'Reina, desperate to bridge the gap, invites Eric out for one last night together before the project ends.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'How should I frame the invite?',
              choices: [
                {
                  text: 'Keep It Light',
                  next: {
                    scene: 'aLastAttempt',
                    beat: 'keepItLight'
                  }
                },
                {
                  text: 'Be Honest About Her Feelings',
                  next: {
                    scene: 'aLastAttempt',
                    beat: 'beHonest'
                  }
                }
              ]
            }
          ]
        },
        keepItLight: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'One last night in Bali—come out with me? No work talk.'
            },
            {
              type: 'showNarration',
              text: 'Eric: (delayed reply) Can\'t. Got stuff to do.'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.5
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'He\'s already letting go.'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'theGoodbyeThatNeverHappens',
            beat: 'theAirportDeparture'
          }
        },
        beHonest: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'I feel like we\'re losing something, and I don\'t know why. Can we talk?'
            },
            {
              type: 'showNarration',
              text: 'Eric: (seen, no reply).'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.5
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'He\'s already letting go.'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'theGoodbyeThatNeverHappens',
            beat: 'theAirportDeparture'
          }
        }
      }
    },
    theGoodbyeThatNeverHappens: {
      beats: {
        theAirportDeparture: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBeach'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'The project is over. Everyone is heading home. Reina keeps glancing at her phone, half-hoping Eric will show up to say goodbye.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'What should I do?',
              choices: [
                {
                  text: 'Send One Last Message',
                  next: {
                    scene: 'theGoodbyeThatNeverHappens',
                    beat: 'sendLastMessage'
                  }
                },
                {
                  text: 'Leave Without a Word',
                  next: {
                    scene: 'theGoodbyeThatNeverHappens',
                    beat: 'leaveWithoutWord'
                  }
                }
              ]
            }
          ]
        },
        sendLastMessage: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'I guess this is it. Safe travels, Eric.'
            },
            {
              type: 'showNarration',
              text: 'Eric: (message delivered. No reply).'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.7
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'I shouldn\'t have come.'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'theChoiceThatChangesEverything',
            beat: 'theDecision'
          }
        },
        leaveWithoutWord: {
          events: [
            {
              type: 'showNarration',
              text: 'Reina puts her phone away. If he wanted to say goodbye, he would\'ve.'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.7
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'I shouldn\'t have come.'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'theChoiceThatChangesEverything',
            beat: 'theDecision'
          }
        }
      }
    },
    theChoiceThatChangesEverything: {
      beats: {
        theDecision: {
          events: [
            {
              type: 'showLocation',
              locationId: 'hotelRoom'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'Reina is back home. The weight of it all is crushing. She can\'t stop thinking about it—the silence, the unanswered questions, the way he pulled away without explanation. But what now?'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'What should I do next?',
              choices: [
                {
                  text: 'Let It Go',
                  goToChapter: {
                    chapter: 'chapter6'
                  }
                },
                {
                  text: 'Fight for Answers',
                  goToChapter: {
                    chapter: 'chapter7'
                  }
                },
                {
                  text: 'Move On With Time',
                  goToChapter: {
                    chapter: 'chapter8'
                  }
                },
                {
                  text: 'Confront Him, No Matter the Cost',
                  goToChapter: {
                    chapter: 'chapter9'
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
